export interface AskConfirmationConfirm {
  type: 'confirm';
}

export interface AskConfirmationCancel {
  type: 'cancel';
}

export type AskConfirmationOutputData =
  | AskConfirmationConfirm
  | AskConfirmationCancel;
